// import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 8,
    right: isMobile ? 5 : 45,
    bottom: 30,
    left: 0,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    height,
    initialWidth,
    initialHeight,
    margins,
    width,
  };
}
